<template>
  <div class="color-picker" @click.stop>
    <button
      class="cp-trigger"
      :style="{ backgroundColor: currentColor || '#f0f2f5' }"
      @click="togglePicker"
    >
      <span class="cp-trigger__hex" :style="{ color: textColor }">
        {{ currentColor || 'Sin color' }}
      </span>
      <i class="fas fa-chevron-down cp-trigger__icon" :style="{ color: textColor }"></i>
    </button>
    <div v-if="isOpen" class="cp-panel">
      <input type="color" v-model="currentColor" class="cp-panel__native" />
      <input
        type="text"
        v-model="currentColor"
        class="input is-small cp-panel__hex-input"
        placeholder="#000000"
        maxlength="7"
        @input="validateHex"
      />
      <button class="cp-panel__close" @click="isOpen = false">Cerrar</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ColorPicker',
  props: {
    value: {
      type: String,
      default: '#000000'
    }
  },
  data () {
    return {
      isOpen: false,
      currentColor: this.value
    }
  },
  watch: {
    currentColor (newVal) {
      this.$emit('input', newVal)
    },
    value (newVal) {
      this.currentColor = newVal
    }
  },
  computed: {
    textColor () {
      const c = (this.currentColor || '').replace('#', '')
      if (c.length === 6) {
        const r = parseInt(c.substr(0, 2), 16)
        const g = parseInt(c.substr(2, 2), 16)
        const b = parseInt(c.substr(4, 2), 16)
        const yiq = (r * 299 + g * 587 + b * 114) / 1000
        return yiq >= 128 ? '#000' : '#fff'
      }
      return '#333'
    }
  },
  methods: {
    togglePicker () {
      this.isOpen = !this.isOpen
    },
    validateHex () {
      const hex = this.currentColor
      if (!/^#([0-9A-Fa-f]{6})$/.test(hex)) return
      this.$emit('input', hex)
    }
  }
}
</script>

<style lang="scss" scoped>
.color-picker {
  position: relative;
  display: block;
}

.cp-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 148px;
  height: 38px;
  border-radius: 8px;
  border: none;
  padding: 0 12px;
  cursor: pointer;
  transition: opacity 0.15s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);

  &:hover {
    opacity: 0.88;
  }

  &__hex {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.4px;
  }

  &__icon {
    font-size: 9px;
    opacity: 0.7;
  }
}

.cp-panel {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 9999;
  width: 172px;
  padding: 12px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.14);
  border: 1px solid #eef0f3;

  &__native {
    width: 100%;
    height: 72px;
    border: none;
    border-radius: 6px;
    padding: 0;
    cursor: pointer;
    display: block;
    margin-bottom: 8px;
  }

  &__hex-input {
    border-radius: 6px !important;
    font-size: 13px;
    font-weight: 500;
    width: 100%;
  }

  &__close {
    display: block;
    width: 100%;
    margin-top: 8px;
    background: none;
    border: none;
    font-size: 12px;
    color: #4c70ff;
    cursor: pointer;
    text-align: center;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
